<template>
  <div class="body">
    <div class="title">{{ $t('lang.WithdrawalSuccessful.title') }}</div>
    <div class="timeLineBox">
      <div class="lineBox">
        <div class="line1" v-if="getTransactionStatus(TransactionStatus) ==='Processing'">
          <div class="line">
            <div class="lineTop"></div>
            <div class="lineBottom"></div>
          </div>
          <div class="LineNode1"></div>
          <div class="LineNode2"></div>
          <div :class="!checkTimeIsExpired()?'LineTimeNode':'LineTimeNode-1'">
            <div class="clock">
              <div class="item1"></div>
              <div  class="item2"></div>
            </div>
          </div>
          <div class="LineNode3"></div>
        </div>
        <div class="line2" v-if="getTransactionStatus(TransactionStatus) ==='Done' || getTransactionStatus(TransactionStatus) ==='Rejected'">
          <div class="line">
            <div class="lineTop"></div>
            <div class="lineTop"></div>
          </div>
          <div class="LineNode1"></div>
          <div class="LineNode2"></div>
          <div class="LineTimeNode2" v-if="getTransactionStatus(TransactionStatus) ==='Done'">
            <img src="../../assets/images/WithdrawalSuccessful/ok.png" alt="">
          </div>
          <div class="LineTimeNode3"  v-if="getTransactionStatus(TransactionStatus) ==='Rejected'">
            <img src="../../assets/images/WithdrawalSuccessful/no.png" alt="">
          </div>
          <div class="LineNode3"></div>
        </div>
      </div>
      <div class="textBox">
        <div class="textBox1">
          {{ $t('lang.WithdrawalSuccessful.initiateWithdrawal') }}
        </div>
        <div class="textBox2">
         <div :class="!checkTimeIsExpired?'text':'text1'"> {{ $t('lang.WithdrawalSuccessful.theBankIsProcessingIt') }}</div>
         <div class="tip" v-if="nowTimeAndAccount.account">{{ getTimeAndAccount($t('lang.WithdrawalSuccessful.ifCompensation')) }}</div>
          <div class="timeNumBox">
            <div :class="getTransactionStatus(TransactionStatus) ==='Processing' && !checkTimeIsExpired()?'num':'num2'">{{ times.hours }}</div> ：<div :class="getTransactionStatus(TransactionStatus) ==='Processing' && !checkTimeIsExpired()?'num':'num2'">{{ times.minutes  }}</div>：<div :class="getTransactionStatus(TransactionStatus) ==='Processing' && !checkTimeIsExpired()?'num':'num2'">{{ times.seconds }}</div>
          </div>
          <div @click="getAccount()" class="claimBtn" v-if="claimShow === 1">{{ $t('lang.WithdrawalSuccessful.claimNow') }} ₹{{getcompensateNums(ConfigList[0].Rate)}}</div>
          <div @click="getAccount()" class="claimBtn" v-if="claimShow === 2">{{ $t('lang.WithdrawalSuccessful.claimNow') }} ₹{{getcompensateNums(ConfigList[1].Rate)}}</div>
        </div>
        <div class="textBox3" v-if="getTransactionStatus(TransactionStatus) ==='Processing'">
          {{ $t('lang.WithdrawalSuccessful.theBankHasTransferred') }}
        </div>
        <div class="textBox3-1" v-if="getTransactionStatus(TransactionStatus) ==='Done' || getTransactionStatus(TransactionStatus) ==='Rejected'">
          <span  v-if="getTransactionStatus(TransactionStatus) ==='Done'">{{ $t('lang.WithdrawalSuccessful.fundsArrived') }}</span>
          <span v-if="getTransactionStatus(TransactionStatus) ==='Rejected'">{{ $t('lang.WithdrawalSuccessful.reject') }}</span>
        </div>
      </div>
    </div>
    <div class="okBtn" @click="back()">
      {{ $t('lang.WithdrawalSuccessful.ok') }}
    </div>
    <div class="infoBox">
      <div class="labelBox">
        <div class="label">{{ $t('lang.WithdrawalSuccessful.withdrawalStatus') }}</div>
        <div class="label">{{ $t('lang.WithdrawalSuccessful.withdrawalAmount') }}</div>
        <div class="label">{{ $t('lang.WithdrawalSuccessful.withdrawalTime') }}</div>
      </div>
     <div class="valueBox">
       <div class="value">{{ getTransactionStatusText(TransactionStatus) }}</div>
       <div class="value">₹{{withdrawAmount}}</div>
       <div class="value">{{Transaction?Transaction.TransactionDate:getCurrentDateTime()}}</div>
     </div>
    </div>
  </div>
</template>

<script>
import request from '../../service'

export default {
  name: 'index',
  data () {
    return {
      finish: 0,
      ConfigList: [],
      withdrawAmount: 0,
      TransactionStatus: 'Processing',
      times: {
        hours: '00',
        minutes: '00',
        seconds: '00',
        isExpired: true
      },
      nowTimeAndAccount: {
        time: '',
        account: ''
      },
      Transaction: {
        TransactionDate: this.getCurrentDateTime()
      },
      timeInterval: null,
      Claim1Show: false,
      Claim2Show: false,
      claimShow: 0,
      claimStatus: {
        Index1Collected: false,
        Index2Collected: false
      }
    }
  },
  mounted () {
    /*
    * 提款页面传过来的数据只有提款金额withdrawAmount，这个时候的TransactionStatus固定为'processing'
    * a
    * */
    // 从提款页面进入到该页面withdrawAmount取值，订单时间用当前时间
    if (this.$route.query.withdrawAmount) {
      this.withdrawAmount = this.$route.query.withdrawAmount
      this.Transaction.TransactionDate = this.getCurrentDateTime()
    } else {
      let Transaction = JSON.parse(this.$route.query.Transaction)
      this.withdrawAmount = Transaction.Amount
      this.Transaction = Transaction
      this.TransactionStatus = Transaction.Status
    }
    this.getWithdrawConfig()
  },
  beforeDestroy () {
    clearInterval(this.timeInterval)
  },
  methods: {
    getAccount () {
      request('post', 'innovation/payments/get/withdraw/delay/bonus', {TransactionUuid: this.Transaction.TransactionUuid}).then(res => {
        if (res.Code === 1) {
          this.$router.push({
            path: '/Message',
            query: {
              tabSelected: 'personal'
            }
          })
        }
      })
    },
    getTimeAndAccount (val) {
      return val.replace('{time}', this.nowTimeAndAccount.time).replace('{account}', this.nowTimeAndAccount.account)
    },
    init () {
      if (this.$route.query.withdrawAmount) {
        this.withdrawAmount = this.$route.query.withdrawAmount
        this.Transaction.TransactionDate = this.getCurrentDateTime()
        // 先判断第一个配置是否配置了，传入倒计时时间和当前时间(订单创建时间)。判断是否已经过期，第一个配置存在并且当前倒计时还未过期，才显示第一个配置的倒计时时间,否则显示第二个配置
        if (this.ConfigList[0] && !this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired && !this.checkTimeIsExpired()) {
          this.nowTimeAndAccount.time = this.ConfigList[0].Time
          this.nowTimeAndAccount.account = this.getcompensateNums()
          this.timeInterval = setInterval(() => {
            if (this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired) {
              clearInterval(this.timeInterval)
              if (this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired) {
                clearInterval(this.timeInterval)
                this.getWithdrawConfig()
              }
            }
            this.times = this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate)
          }, 1000)
        } else if (this.ConfigList[1] && !this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired && !this.checkTimeIsExpired()) {
          this.nowTimeAndAccount.time = this.ConfigList[1].Time
          this.nowTimeAndAccount.account = this.getcompensateNums()
          this.timeInterval = setInterval(() => {
            if (this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired) {
              clearInterval(this.timeInterval)
              if (this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired) {
                clearInterval(this.timeInterval)
                this.getWithdrawConfig()
              }
            }
            this.times = this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate)
          }, 1000)
        }
      } else {
        let Transaction = JSON.parse(this.$route.query.Transaction)
        this.withdrawAmount = Transaction.Amount
        this.Transaction = Transaction
        this.TransactionStatus = Transaction.Status
        // 先判断第一个配置是否配置了，传入倒计时时间和订单创建时间。判断是否已经过期，第一个配置存在并且当前倒计时还未过期，才显示第一个配置的倒计时时间,否则显示第二个配置
        if (this.ConfigList[0] && !this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired && !this.checkTimeIsExpired()) {
          this.nowTimeAndAccount.time = this.ConfigList[0].Time
          this.nowTimeAndAccount.account = this.withdrawAmount * this.ConfigList[0].Rate
          this.times = this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate)
          this.timeInterval = setInterval(() => {
            this.times = this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate)
            if (this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired) {
              clearInterval(this.timeInterval)
              this.getWithdrawConfig()
            }
          }, 1000)
        } else if (this.ConfigList[1] && !this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired && !this.checkTimeIsExpired()) {
          this.nowTimeAndAccount.time = this.ConfigList[1].Time
          this.nowTimeAndAccount.account = this.withdrawAmount * this.ConfigList[1].Rate
          this.times = this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate)
          this.timeInterval = setInterval(() => {
            this.times = this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate)
            if (this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired) {
              clearInterval(this.timeInterval)
              this.getWithdrawConfig()
            }
          }, 1000)
        }
      }
      this.getClaimShow()
      if (this.getTransactionStatus(this.TransactionStatus) !== 'Processing') {
        clearInterval(this.timeInterval)
      }
    },
    getClaimShow () {
      // index: 0(不可领) 1(第一阶段可领) 2(第二阶段可领)
      request('post', 'innovation/payments/get/withdraw/delay/index', {TransactionUuid: this.Transaction.TransactionUuid}).then(res => {
        if (res) {
          this.claimShow = res.Index
          if (this.claimShow === 1 || this.claimShow === 2) {
            this.getAccount()
            this.getClaimShow()
          }
        }
      })
    },
    setClaim1Show () {
      // 判断第一阶段和第二阶段都到期时候，比较他们的补偿金大小,大的返回true
      if (this.ConfigList[0] && this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired && !this.claimStatus.Index1Collected && this.ConfigList[1] && (this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired ? ((this.ConfigList[0].Rate * this.withdrawAmount) > (this.ConfigList[1].Rate * this.withdrawAmount)) : true) && !this.claimStatus.Index2Collected) {
        this.Claim1Show = true
        // eslint-disable-next-line no-mixed-operators
      } else if (this.ConfigList[0] && this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired && !this.claimStatus.Index1Collected && (!this.ConfigList[1] || !this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired)) {
        this.Claim1Show = true
      } else {
        this.Claim1Show = false
      }
    },
    setClaim2Show () {
      if (this.ConfigList[1] && this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired && !this.claimStatus.Index2Collected && (!this.claimStatus.Index1Collected ? (this.ConfigList[1].Rate * this.withdrawAmount > this.ConfigList[0].Rate * this.withdrawAmount) : true)) {
        this.Claim2Show = true
      } else {
        this.Claim2Show = false
      }
    },
    calculateTimeRemaining (hours, targetDateTime) {
      // 解析目标时间为印度时间（UTC+5:30）
      const parseIndiaTime = (datetimeStr) => {
        const [datePart, timePart] = datetimeStr.split(' ')
        const [y, m, d] = datePart.split('-').map(Number)
        const [H, M, S] = timePart.split(':').map(Number)
        // 转换为印度时间对应的UTC时间戳
        return Date.UTC(y, m - 1, d, H - 5, M - 30, S) // UTC = 印度时间 - 5h30m
      }

      // 计算截止时间（印度时间 + 小时数）
      const indiaDeadlineUTC = parseIndiaTime(targetDateTime) + hours * 3600 * 1000

      // 获取当前UTC时间
      const nowUTC = Date.now()

      // 计算剩余时间（统一用UTC时间戳计算）
      const diff = indiaDeadlineUTC - nowUTC

      if (diff < 0) {
        return {
          hours: '00',
          minutes: '00',
          seconds: '00',
          isExpired: true,
          formatted: '00:00:00'
        }
      }

      // 时间分量计算
      const totalSeconds = Math.floor(diff / 1000)
      const hoursRemaining = Math.floor(totalSeconds / 3600)
      const minutesRemaining = Math.floor((totalSeconds % 3600) / 60)
      const secondsRemaining = totalSeconds % 60

      // 补零函数
      const pad = n => n.toString().padStart(2, '0')
      return {
        hours: pad(hoursRemaining),
        minutes: pad(minutesRemaining),
        seconds: pad(secondsRemaining),
        isExpired: false,
        formatted: `${pad(hoursRemaining)}:${pad(minutesRemaining)}:${pad(secondsRemaining)}`
      }
    },
    checkTimeIsExpired () {
      if (this.ConfigList[1] && this.calculateTimeRemaining(this.ConfigList[1].Time, this.Transaction.TransactionDate).isExpired) {
        return true
      } else if (this.ConfigList[0] && !this.ConfigList[1] && this.calculateTimeRemaining(this.ConfigList[0].Time, this.Transaction.TransactionDate).isExpired) {
        return true
      } else {
        return false
      }
    },
    getCurrentDateTime () {
      // 使用印度时区（UTC+5:30）
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // 强制24小时制
      })

      // 提取并格式化为两位数
      const parts = formatter.formatToParts(new Date())
      const getValue = (type) => {
        const part = parts.find(p => p.type === type)
        return part ? part.value : '00'// 存在性检查
      }

      // 获取各部分并强制补零
      const year = getValue('year')
      const month = getValue('month').padStart(2, '0')// 月份补零
      const day = getValue('day').padStart(2, '0') // 日期补零
      const hours = getValue('hour').padStart(2, '0') // 小时补零
      const minutes = getValue('minute').padStart(2, '0')
      const seconds = getValue('second').padStart(2, '0')

      // 返回印度时间
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`.trim()
    },
    getTransactionStatus (status) {
      if (status === 'awaiting approval') {
        return 'Processing'
      } else if (status === 'Processing') {
        return 'Processing'
      } else if (status === 'done') {
        return 'Done'
      } else if (status === 'rejected') {
        return 'Rejected'
      } else {
        return 'Processing'
      }
    },
    getTransactionStatusText (status) {
      if (status === 'awaiting approval') {
        return this.$t('lang.WithdrawalSuccessful.Processing')
      } else if (status === 'Processing') {
        return this.$t('lang.WithdrawalSuccessful.Processing')
      } else if (status === 'done') {
        return this.$t('lang.WithdrawalSuccessful.Done')
      } else if (status === 'rejected') {
        return this.$t('lang.WithdrawalSuccessful.Rejected')
      } else {
        return this.$t('lang.WithdrawalSuccessful.Processing')
      }
    },
    getcompensateNums (rate) {
      if (rate) {
        return Math.round(this.withdrawAmount * rate)
      } else {
        return ''
      }
    },
    getWithdrawConfig () {
      request('get', 'innovation/payments/get/withdraw/delay/config').then(res => {
        this.ConfigList = res.ConfigList
        this.getWithdrawStatus()
      })
    },
    getWithdrawStatus () {
      request('post', 'innovation/payments/get/withdraw/delay/status', {TransactionUuid: this.Transaction.TransactionUuid}).then(res => {
        if (res) {
          this.claimStatus = res
          this.init()
        }
      })
    },
    back () {
      clearInterval(this.timeInterval)
      this.$router.replace('/Home')
    }
  }
}
</script>

<style lang="less" scoped>
.body{
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: absolute;
  box-sizing: border-box;
  padding: 4vw 10vw;
  .title{
    height: 10vw;
    //border: 1px solid red;
    line-height: 10vw;
    color: #F6D9AA;
    font-weight: 700;
    font-size: 6.11vw;
    font-family: Arial;
    margin-left: -1.8vw;
  }
  .timeLineBox{
    height: 88.858vw;
    width: 76.94vw;
    display: flex;
    //border: 1px solid red;
    margin-top: 5vw;
    .lineBox{
      height: 77.77vw;
      .line1{
        height: 100%;
        position: relative;
        .line{
          height: 100%;
          display: flex;
          flex-direction: column;
          .lineTop{
            height: 50%;
            border: 0.4vw dashed #715B37;
          }
          .lineBottom{
            //margin-top: 2vw;
            height: 50%;
            height: 50%;
            border: 0.4vw dashed #353535;
          }
        }
        .LineNode1{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #715B37;
          position: absolute;
          border-radius: 100vw;
          top: 0vw;
          left:-1.5vw;
        }
        .LineNode2{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #715B37;
          position: absolute;
          border-radius: 100vw;
          top: 37vw;
          left:-1.5vw;
        }
        @keyframes glow {
          0% {
            box-shadow:
              0 0 2px 1px rgba(255, 212, 133, 0.5), /* 内层光晕 */
              0 0 5px 2px rgba(255, 212, 133, 0.3), /* 中层光晕 */
              0 0 10px 3px rgba(255, 212, 133, 0.1); /* 外层光晕 */
          }
          50% {
            box-shadow:
              0 0 7px 3px rgba(255, 212, 133, 0.6), /* 内层光晕 */
              0 0 12px 6px rgba(255, 212, 133, 0.4), /* 中层光晕 */
              0 0 17px 8px rgba(255, 212, 133, 0.2); /* 外层光晕 */
          }
          100% {
            box-shadow:
              0 0 2px 1px rgba(255, 212, 133, 0.5), /* 内层光晕 */
              0 0 5px 2px rgba(255, 212, 133, 0.3), /* 中层光晕 */
              0 0 10px 3px rgba(255, 212, 133, 0.1); /* 外层光晕 */
          }
        }
        .LineTimeNode-1 {
          height: 10.5vw;
          width: 10.5vw;
          position: absolute;
          border-radius: 100vw;
          top: 33vw;
          left: -5vw;
          background-image: radial-gradient(circle, #FFF6D3, #FFD485);
          //animation: glow 1s ease-in-out infinite;
          display: flex;
          align-items: center;
          justify-content: center;
          .clock {
            position: relative;
            width: 7vw;
            height: 7vw;
            //background-color: red;
            border: 0.7vw solid #000;
            border-radius: 10vw;
            // 时针
            .item1 {
              position: absolute;
              left: 50%;
              top: 50%;
              width: 0.7vw;
              height: 2.5vw;
              background: #000;
              border-radius: 4vw;
              transform: translate(-50%, -90%);
            }

            // 分针（核心修正部分）
            .item2{
              position: absolute;
              left: 48%;      // 关键点：定位到父容器中心
              top: 49%;       // 关键点：定位到父容器中心
              width: 0.7vw;
              height: 2.2vw;
              background: #000;
              border-radius: 4vw;
              transform:
                translate(-50%, -100%)  // 关键点：向上偏移高度(使底部居中)
                rotate(90deg);          // 初始角度指向3点钟方向
              transform-origin: bottom center; // 关键点：底部为旋转中心
              //animation: rotate 3s linear infinite;
            }
          }
        }
        .LineTimeNode{
          height: 10.5vw;
          width: 10.5vw;
          position: absolute;
          border-radius: 100vw;
          top: 33vw;
          left: -5vw;
          background-image: radial-gradient(circle, #FFF6D3, #FFD485);
          animation: glow 1s ease-in-out infinite;
          display: flex;
          align-items: center;
          justify-content: center;
          // 时钟容器
          .clock {
            position: relative;
            width: 7vw;
            height: 7vw;
            //background-color: red;
            border: 0.7vw solid #000;
            border-radius: 10vw;

            // 时针
            .item1 {
              position: absolute;
              left: 50%;
              top: 50%;
              width: 0.7vw;
              height: 2.5vw;
              background: #000;
              border-radius: 4vw;
              transform: translate(-50%, -90%);
            }

            // 分针（核心修正部分）
            .item2{
              position: absolute;
              left: 48%;      // 关键点：定位到父容器中心
              top: 49%;       // 关键点：定位到父容器中心
              width: 0.7vw;
              height: 2.2vw;
              background: #000;
              border-radius: 4vw;
              transform:
                translate(-50%, -100%)  // 关键点：向上偏移高度(使底部居中)
                rotate(90deg);          // 初始角度指向3点钟方向
              transform-origin: bottom center; // 关键点：底部为旋转中心
              animation: rotate 3s linear infinite;
            }
          }

          // 旋转动画（修正后的版本）
          @keyframes rotate {
            0% {
              transform:
                translate(-50%, -100%)
                rotate(90deg);  // 初始角度
            }
            100% {
              transform:
                translate(-50%, -100%)
                rotate(450deg); // 结束角度 = 90 + 360
            }
          }
        }
        .LineNode3{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #2C2C2C;
          position: absolute;
          border-radius: 100vw;
          left:-1.5vw;
        }
      }
      .line2{
        height: 100%;
        position: relative;
        .line{
          height: 100%;
          display: flex;
          flex-direction: column;
          .lineTop{
            height: 50%;
            border: 0.4vw dashed #715B37;
          }
          .lineBottom{
            //margin-top: 2vw;
            height: 50%;
            height: 50%;
            border: 0.4vw dashed #353535;
          }
        }
        .LineNode1{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #715B37;
          position: absolute;
          border-radius: 100vw;
          top: 0vw;
          left:-1.5vw;
        }
        .LineTimeNode2{
          height: 10.5vw;
          width: 10.5vw;
          position: absolute;
          border-radius: 100vw;
          top: 74vw;
          left: -5vw;
          background-image: radial-gradient(circle, #8AFF3D, #23FF20);
          //animation: glow1 1s ease-in-out infinite;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          box-shadow:
            0 0 7px 2px rgba(138, 255, 61, 0.6),
            0 0 20px 2px rgba(35, 255, 32, 0.4),
            0 0 15px 2px rgba(35, 255, 32, 0.2);
          img{
            height: 5.10vw;
            width: 6.811vw;
          }
        }
        .LineTimeNode3{
          height: 10.5vw;
          width: 10.5vw;
          position: absolute;
          border-radius: 100vw;
          top: 74vw;
          left: -5vw;
          background-image: radial-gradient(circle, #D82501, #C02000);
          //animation: glow2 1s ease-in-out infinite;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          box-shadow:
            0 0 7px 2px rgba(216, 37, 1, 0.6),    /* 内层加强 #D82501 */
            0 0 20px 2px rgba(192, 32, 0, 0.4),    /* 中层加强 #C02000 */
            0 0 15px 2px rgba(192, 32, 0, 0.2);    /* 外层加强 #C02000 */
          img{
            height: 5.788vw;
            width: 5.788vw;
          }
        }
        .LineNode2{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #715B37;
          position: absolute;
          border-radius: 100vw;
          top: 37.5vw;
          left:-1.5vw;
        }
        @keyframes glow1 {
          0%, 100% {
            box-shadow:
              0 0 2px 1px rgba(138, 255, 61, 0.5),    /* 内层光晕 #8AFF3D */
              0 0 5px 2px rgba(35, 255, 32, 0.3),     /* 中层光晕 #23FF20 */
              0 0 10px 3px rgba(35, 255, 32, 0.1);    /* 外层光晕 #23FF20 */
          }
          50% {
            box-shadow:
              0 0 7px 3px rgba(138, 255, 61, 0.6),    /* 内层光晕 #8AFF3D */
              0 0 12px 6px rgba(35, 255, 32, 0.4),    /* 中层光晕 #23FF20 */
              0 0 17px 8px rgba(35, 255, 32, 0.2);    /* 外层光晕 #23FF20 */
          }
        }
        @keyframes glow2 {
          0%, 100% {
            box-shadow:
              0 0 2px 1px rgba(216, 37, 1, 0.5),    /* 内层 #D82501 */
              0 0 5px 2px rgba(192, 32, 0, 0.3),    /* 中层 #C02000 */
              0 0 10px 3px rgba(192, 32, 0, 0.1);   /* 外层 #C02000 */
          }
          50% {
            box-shadow:
              0 0 7px 3px rgba(216, 37, 1, 0.6),    /* 内层加强 #D82501 */
              0 0 12px 6px rgba(192, 32, 0, 0.4),    /* 中层加强 #C02000 */
              0 0 17px 8px rgba(192, 32, 0, 0.2);    /* 外层加强 #C02000 */
          }
        }
        .LineTimeNode{
          height: 10.5vw;
          width: 10.5vw;
          position: absolute;
          border-radius: 100vw;
          top: 33vw;
          left: -5vw;
          background-image: radial-gradient(circle, #FFF6D3, #FFD485);
          animation: glow 1s ease-in-out infinite;
          display: flex;
          align-items: center;
          justify-content: center;
          // 时钟容器
          .clock {
            position: relative;
            width: 7vw;
            height: 7vw;
            //background-color: red;
            border: 0.7vw solid #000;
            border-radius: 10vw;

            // 时针
            .item1 {
              position: absolute;
              left: 50%;
              top: 50%;
              width: 0.7vw;
              height: 2.5vw;
              background: #000;
              border-radius: 4vw;
              transform: translate(-50%, -90%);
            }

            // 分针（核心修正部分）
            .item2 {
              position: absolute;
              left: 48%;      // 关键点：定位到父容器中心
              top: 49%;       // 关键点：定位到父容器中心
              width: 0.7vw;
              height: 2.2vw;
              background: #000;
              border-radius: 4vw;
              transform:
                translate(-50%, -100%)  // 关键点：向上偏移高度(使底部居中)
                rotate(90deg);          // 初始角度指向3点钟方向
              transform-origin: bottom center; // 关键点：底部为旋转中心
              animation: rotate 3s linear infinite;
            }
          }

          // 旋转动画（修正后的版本）
          @keyframes rotate {
            0% {
              transform:
                translate(-50%, -100%)
                rotate(90deg);  // 初始角度
            }
            100% {
              transform:
                translate(-50%, -100%)
                rotate(450deg); // 结束角度 = 90 + 360
            }
          }
        }
        .LineNode3{
          height: 3.61vw;
          width: 3.61vw;
          background-color: #2C2C2C;
          position: absolute;
          border-radius: 100vw;
          left:-1.5vw;
        }
      }
    }
  }
  .textBox{
    height: 81.94vw;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 10vw;
    .textBox1{
      font-size: 4.44vw;
      color: #898989;
    }
    .textBox2{
      font-size: 4.72vw;
      color: #fff;
      position: relative;
      top: 5vw;
      .text{
        font-weight: 700;
      }
      .text1{
        font-weight: 500;
        font-size: 4.44vw;
        color: #898989;
      }
      .tip{
        font-size: 3.33vw;
        color: #898989;
      }
      .timeNumBox{
        width: 46.583vw;
        height: 12.77vw;
        font-size: 8.33vw;
        color: #979797;
        display: flex;
        align-items: center;
        position: relative;
        top: 1vw;
        .num{
          font-size: 7.5vw;
          color: #fff;
          height: 12.77vw;
          width: 12.155vw;
          background-color: #000000;
          border-radius: 1.66vw;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .num2{
          font-size: 7.5vw;
          color: #fff;
          height: 12.77vw;
          width: 12.155vw;
          background-color: #000000;
          border-radius: 1.66vw;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #484848;
        }
        .num:nth-child(2){
          margin-left: -4vw;
        }
        .num:nth-child(3){
          margin-left: -4vw;
        }
      }
      .claimBtn{
        width: 32.05vw;
        height: 8.05vw;
        color: #E1C18D;
        border: 1px solid #E1C18D;
        border-radius: 1.11vw;
        font-size: 3.05vw;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        top: 3vw;
        margin-bottom: 4vw;
      }
    }
    .textBox3{
      font-size: 4.44vw;
      color: #898989;
    }
    .textBox3-1{
      span{
        color: #fff;
        font-weight: 700;
        font-size: 4.72vw
      }
    }
  }
  .okBtn{
    width: 83.447vw;
    height: 11.68vw;
    background-color: #F6D9AA;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1.544vw;
    font-size: 4.305vw;
    font-weight: bold;
    margin-left: -1.8vw;
    margin-top: 5vw;
  }
  .infoBox{
    width: 83.447vw;
    display: flex;
    justify-content: space-between;
    //border: 1px solid red;
    margin-top: 5.41vw;
    height: 20vw;
    margin-left: -1.8vw;
    .labelBox{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #777777;
      font-size: 3.88vw;
      font-weight: 700;
    }
    .valueBox{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #fff;
      font-size: 3.88vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WithdrawalSuccessful/index.vue